module.exports = __webpack_public_path__ + "static/img/userHD.1209313f.png";